enum EModuleIds {
    OVERVIEW = 1,
    OPERATIONS = 2,
    LOGISTICS = 3,
    VENDORS = 4,
    ADMIN = 5,
    SETTINGS = 6,
    FINANCE = 8,
    ONBOARDING = 9,
    THIRDPARTY = 12,
    PROJECTS = 7,
    CUSTOMER_SUPPORT = 11,
    TECHSUPPORT = 10,
    NETWORK_RELIABILITY = 13,
    ACCOUNTS = 14,
    SITES = 15,
    PROGRAMS = 18,
    COMPLAINTS = 19,
    APPROVALS = 20,
    TAGS = 17,
    // SCM groups Logistics and Dispatch Request as submodules (see ESubModuleIds below), the same
    // way OPERATIONS groups Installation/EV Application/Survey/Demolition. Use this (+ the
    // matching submodule id) for permission/role lookups and sidebar nav for either feature —
    // EModuleIds.LOGISTICS below is unrelated: it's the business/ticket-domain id (still 3) used
    // by ticket records, forms, and tag scoping.
    SCM = 23,
    PURCHASE_ORDERS = 24,
    HANDOVER_TAKEOVER = 25,
    // TEMP/PLACEHOLDER: Warehouse Outward has no backend module_id yet under SCM — 26 is just the
    // next free id (25 is Handover & Takeover). Confirm the real value (and whether it becomes an
    // SCM submodule too) with backend before go-live, and update this + the matching entry in
    // sideMenuModules.ts.
    WAREHOUSE_OUTWARD = 26,
}

enum ESubModuleIds {
    INSTALLATION = 1,
    EV_APPLICATION = 2,
    SURVEY = 12,
    DEMOLITION = 21,
    // SCM (module_id 23) submodules
    LOGISTICS = 22,
    DISPATCH_REQUEST = 24,
    // Confirmed by backend (Warehouse Outward API contract, 2026-10-23): submodules row id 25 under
    // SCM. Doc hub, comments and the sidebar key on SCM + this id.
    WAREHOUSE_OUTWARD = 25,
}

export default EModuleIds
export { ESubModuleIds }
